module.exports = __webpack_public_path__ + "static/media/pets.3fc389cc.png";